import { useEffect, useState } from 'react';
import api from '@/lib/api';

function normalizePhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('62')) return digits;
  if (digits.startsWith('0')) return '62' + digits.slice(1);
  if (digits.startsWith('8')) return '62' + digits;
  return digits;
}

export default function FloatingWhatsApp() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/widget-settings')
      .then((res) => { if (!cancelled) setCfg(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!cfg?.whatsapp_widget_enabled) return null;
  const phone = normalizePhone(cfg.support_whatsapp);
  if (!phone) return null;

  const message = cfg.whatsapp_widget_message || 'Halo, saya ingin bertanya tentang Tokomoe.';
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat support via WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1FB955] text-white rounded-full shadow-xl shadow-emerald-500/30 px-4 py-3 transition-all hover:scale-105"
    >
      <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M16.003 3.2c-7.07 0-12.8 5.728-12.8 12.798 0 2.255.591 4.46 1.713 6.4L3.2 28.8l6.585-1.687a12.79 12.79 0 0 0 6.218 1.585h.005c7.066 0 12.797-5.728 12.797-12.797 0-3.418-1.33-6.633-3.748-9.052a12.74 12.74 0 0 0-9.054-3.65zm0 23.32h-.004a10.62 10.62 0 0 1-5.412-1.482l-.388-.231-4.012 1.026 1.07-3.91-.252-.4a10.59 10.59 0 0 1-1.628-5.66c.002-5.866 4.78-10.642 10.633-10.642 2.84 0 5.508 1.107 7.515 3.116a10.55 10.55 0 0 1 3.113 7.523c-.003 5.866-4.78 10.642-10.635 10.642zm5.835-7.97c-.32-.16-1.892-.934-2.184-1.04-.293-.107-.506-.16-.72.16-.213.32-.825 1.04-1.012 1.253-.187.213-.373.24-.693.08-.32-.16-1.351-.498-2.575-1.587-.952-.85-1.595-1.9-1.781-2.22-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.624-.524-.539-.72-.55-.187-.008-.4-.01-.613-.01s-.56.08-.853.4c-.293.32-1.12 1.094-1.12 2.667 0 1.573 1.146 3.094 1.306 3.307.16.213 2.255 3.443 5.467 4.83.764.33 1.36.527 1.825.674.767.244 1.466.21 2.018.127.616-.092 1.892-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
      <span className="text-sm font-semibold hidden sm:inline">Chat WhatsApp</span>
    </a>
  );
}
